import api from '../../apiConfig/apiConfig';
import { Post, Get } from '../base/baseAjax';

// 新增/编辑功能API
let welcomeAddOrUpdate = params => {
	return Post({
		url: api.welcomePage.welcomeAddOrUpdate,
		bodyParam: params,
	});
};

// 详情API
let welcomeDetail = params => {
	return Get({
		url: api.welcomePage.welcomeDetail,
		PathParam: params,
	});
};

// 显示开关操作API
let welcomeShowswitch = params => {
	return Get({
		url: api.welcomePage.welcomeShowswitch,
		PathParam: params,
	});
};

// // 路由权限列表,
let menupermissionsPart = params => {
	return Get({
		url: api.welcomePage.menupermissionsPart,
		UrlParam: params,
	});
};

export default {
	welcomeAddOrUpdate,
	welcomeDetail,
	welcomeShowswitch,
	menupermissionsPart,
};
